
export class Messages {

  public static LEGACY_VSP_ORDER_NOT_UPDATABLE_MESSAGE: String = 'This order can not be modified because it was submitted ' +
                                                                  'through a classic ordering portal.\n\n' +
                                                                  'Please void the order and advise the practice to resubmit.';
}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-sandbox-build/src/app/shared/messages.ts